/**
 * Enable tab trapping for the elements selected by the given selectors.
 *
 * @param {string} selectors - The CSS selector string used to exclude elements from tabbing.
 */
const enable = selectors => {
    const $els = document.querySelectorAll(selectors);

    if ($els?.length) {
        $els.forEach(el => {
            // keep track of the original tabindex, if any
            const originalTabIndex = el.getAttribute('tabindex');
            const originalHidden = el.getAttribute('aria-hidden');

            // if already set then return
            if (el.hasAttribute(['data-tabindex']) || el.hasAttribute(['data-aria-hidden'])) return;

            if (originalTabIndex) {
                el.setAttribute('data-tabindex', originalTabIndex);
            }
            if (originalHidden) {
                el.setAttribute('data-aria-hidden', originalHidden);
            }
            el.setAttribute('tabindex', '-1');
            el.setAttribute('aria-hidden', true);
        });
    }
};

/**
 * Disable tab trapping for the elements selected by the given selectors.
 *
 * @param {string} selectors - The CSS selector string used to select elements to restore tabbing.
 */
const disable = selectors => {
    const $els = document.querySelectorAll(selectors);

    if ($els?.length) {
        $els.forEach(el => {
            // Get the original tabindex, if any
            const originalTabIndex = el.getAttribute('data-tabindex');
            const originalHidden = el.getAttribute('data-aria-hidden');

            if (originalTabIndex) {
                el.setAttribute('tabindex', originalTabIndex);
                el.removeAttribute('data-tabindex');
            } else {
                el.removeAttribute('tabindex');
            }

            if (originalHidden) {
                el.setAttribute('aria-hidden', originalHidden);
                el.removeAttribute('data-aria-hidden');
            } else {
                el.removeAttribute('aria-hidden');
            }
        });
    }
};

export default {disable, enable};
